module.exports = __webpack_public_path__ + "static/afexa-card-1bb58c49488c75e2cc78048276374343.png";